import maInputSelect from '../select'
import maModal from '@/components/modal'
import maPoligons from '@/components/poligons'

/**
 * @module
 * @name InputSelectMap
 * @description This component displays a select with predefined options,
 *              as a maInputSelect component, but you can show a map and either
 *              draw polygons or lines to retrieve measure. This map can be
 *              accessed clicking in the text below the select.
 * @extends Input
 */
export default {
  name: 'InputSelectMap',
  extends: maInputSelect,
  components: {
    maModal,
    maPoligons
  },

  /**
   * @property {Float} coordinates.lat Lat coordinate.
   * @property {Float} coordinates.lng Lng coordinate.
   * @property {String} measure Measure type.It could be measure, or line.
   */
  props: {
    coordinates: {
      type: Object
    },
    measure: {
      type: String,
      required: true,
      validator: v => (v.indexOf(['measure', 'line']))
    }
  },

  /**
   * @property {Float} lat Lat coordinate.
   * @property {Float} lng Lng coordinate.
   */
  computed: {
    lat: function () {
      return this.coordinates ? this.coordinates.lat : null
    },
    lng: function () {
      return this.coordinates ? this.coordinates.lng : null
    }
  },

  methods: {
    /**
     * @function
     * @name handleshowModal
     * @description Shows map modal.
     */
    handleShowModal: function () {
      this.$refs[`input${this.type}${this.name}`].showModal = true
    }
  }
}
